// src/i18n.js
// import i18n from 'i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
// import Backend from 'i18next-http-backend';
// import { initReactI18next } from 'react-i18next';
// `fr` directly, `en` as a type only: the dashboard renders French, and a runtime
// `{ en, fr }` object kept the whole English translation (~168 KB) in main.js
// as soon as a lazy chunk (the onboarding tour) imported `translate`.
import type { en } from './i18n/en';
import { fr } from './i18n/fr';

// i18n
//     .use(Backend) // Loads translations from a backend server
//     .use(LanguageDetector) // Detects user language
//     .use(initReactI18next) // Passes i18n instance to react-i18next
//     .init({
//         fallbackLng: 'en', // Default language if translation is not available
//         debug: true, // Enable debug mode for development
//         interpolation: {
//             escapeValue: false, // React already escapes values by default
//         },
//         resources: translations
//     });

type NestedKeyOf<T> = {
    [K in keyof T]-?: T[K] extends object
    ? K extends string
    ? `${K}` | `${K}.${NestedKeyOf<T[K]>}`
    : never
    : K extends string
    ? K
    : never;
}[keyof T];
export type TranslationKeys = NestedKeyOf<typeof en.translation>;

function getNestedProperty(obj: any, path: string) {
    return path.split('.').reduce((acc, key) => {
        return acc && acc[key] !== undefined ? acc[key] : undefined;
    }, obj);
}
export function translate(
    key: TranslationKeys,
    params?: Record<string, string | number>,
) {
    const raw = getNestedProperty(fr.translation, key);
    if (typeof raw !== 'string' || !params) return raw;
    return raw.replace(/\{(\w+)\}/g, (match, name) =>
        name in params ? String(params[name]) : match,
    );
}
